export type LinkedStandardSummary = {
  readonly code: string;
  readonly description: string;
};

export function LessonLinkedStandardsBadge({
  standards,
  variant = "default",
}: {
  readonly standards: readonly LinkedStandardSummary[];
  /** `on-card` uses lighter pill styling for lesson library tiles. */
  readonly variant?: "default" | "on-card";
}) {
  if (standards.length === 0) return null;
  const label = standards.length === 1 ? "1 standard" : `${standards.length} standards`;
  return (
    <span
      className={`teacher-standards-lesson-count${variant === "on-card" ? " teacher-standards-lesson-count--on-card" : ""}`}
    >
      <span className="teacher-standards-lesson-count-value" tabIndex={0}>
        {label}
      </span>
      <span className="teacher-standards-lesson-tooltip" role="tooltip">
        <span className="teacher-standards-lesson-tooltip-title">Aligns with</span>
        <ul>
          {standards.map((standard) => (
            <li key={standard.code}>
              <strong>{standard.code}</strong> {standard.description}
            </li>
          ))}
        </ul>
      </span>
    </span>
  );
}
